import styled from 'styled-components';
import media from '../styles/theme/breakpoints';

const ScreenWrapper = styled.div`
  .MobileLink {
    &:active, &:link, &:hover, &:visited {
      color: ${({ theme }) => theme.colors.neutral[900]};
    }
  }

  .개인정보 {
    display: inline-flex;
    flex-direction: row;
    justify-items: center;
    width: 350px;
    height: 80px;
    font-size: ${({ theme }) => theme.typography.fontSize.xl};
    margin: 0;
    margin-bottom: ${({ theme }) => theme.spacing[3]};
  }

  .계정정보 {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    text-align: left;
    width: 65%;
    height: 80px;
    margin: 0;
    font-size: ${({ theme }) => theme.typography.fontSize.base};
    padding: ${({ theme }) => theme.spacing[1]};
  }

  .프로필사진 {
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: 0 ${({ theme }) => theme.spacing[5]};
    width: 80px;
    height: 80px;
  }

  .NoticeMasterPanel > a, .NoticeMasterPanel a:link, .NoticeMasterPanel a:visited, .NoticeMasterPanel a:active, .NoticeMasterPanel a:hover {
    color: ${({ theme }) => theme.colors.neutral[900]};
  }

  .new_pixBox {
    display: flex;
    flex-direction: column;
  }

  .NewsLink:link, .NewsLink:visited, .NewsLink:active, .NewsLink:hover {
    color: ${({ theme }) => theme.colors.neutral[900]};
    text-decoration: none;
    text-align: left;
  }

  .HeaderLink:link, .HeaderLink:visited, .HeaderLink:active, .HeaderLink:hover {
    color: ${({ theme }) => theme.colors.neutral[900]};
    text-decoration: none;
  }

  .LoginTable {
    border-spacing: 0;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .Finder {
    width: 520px;
    border: 2px solid ${({ theme }) => theme.colors.neutral[700]};
  }

  .FinderBox {
    display: flex;
    justify-content: space-between;
    margin-top: ${({ theme }) => theme.spacing[3]};
    width: 99%;
    align-items: center;

    > h1 { margin: 0; }
    > table { margin: 0; border-spacing: 0; padding: 0; }

    button {
      width: 50px;
      height: 42px;
      background: ${({ theme }) => theme.colors.neutral[700]};
      border: 1px solid ${({ theme }) => theme.colors.neutral[700]};
      border-left: none;
      padding-bottom: ${({ theme }) => theme.spacing[3]};
    }
  }

  .User, .UserName, .Password, .BirthDay, .CheckPassword, .Email {
    width: 250px;
    font-size: 15pt;
  }

  .비밀번호찾기 {
    font-size: ${({ theme }) => theme.typography.fontSize.xs};
    margin-left: ${({ theme }) => theme.spacing[2]};
  }

  .회원가입 {
    font-size: ${({ theme }) => theme.typography.fontSize.xs};
    margin-right: ${({ theme }) => theme.spacing[1]};
  }

  .회원관련창 {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .LoginButton {
    width: 100%;
    height: 40px;
    background: ${({ theme }) => theme.colors.neutral[700]};
    color: ${({ theme }) => theme.colors.neutral[0]};
    font-size: ${({ theme }) => theme.typography.fontSize.base};
    border: none;
    border-radius: ${({ theme }) => theme.borderRadius.sm};
    cursor: pointer;
    transition: background ${({ theme }) => theme.transition.fast};

    &:hover {
      background: ${({ theme }) => theme.colors.neutral[800]};
    }
  }

  .CenterBox {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }

  .UserInfo {
    border: 1px solid ${({ theme }) => theme.colors.neutral[100]};
    border-radius: ${({ theme }) => theme.borderRadius.md};
    width: 100%;
    height: auto;
    padding: ${({ theme }) => theme.spacing[4]};
    background: ${({ theme }) => theme.colors.neutral[0]};
    box-shadow: ${({ theme }) => theme.elevation.sm};
    box-sizing: border-box;
  }

  .pix {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;

    img {
      border: 1px solid ${({ theme }) => theme.colors.neutral[400]};
    }
  }

  .downbutton {
    width: 300px;
    height: 60px;
    align-content: center;
  }

  .CommunityBox {
    display: flex;
    margin-bottom: ${({ theme }) => theme.spacing[8]};
    align-items: center;
    justify-content: center;
  }

  .Wrapper {
    align-items: stretch;
    height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: overlay;
    background: ${({ theme }) => theme.colors.neutral[50]};
  }

  .CompanyMasterPanel,
  .HelpMasterPanel,
  .HomeMasterPanel,
  .PortfolioMasterPanel,
  .ProductMasterPanel,
  .DownloadMasterPanel,
  .NoticeMasterPanel {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 24px 32px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    background: transparent;
    border: none;
  }

  .TextTitle {
    text-decoration: underline;
  }

  .공지사항_헤더 {
    margin: 0;
    margin-left: ${({ theme }) => theme.spacing[1]};
    text-align: left;
  }

  .공지사항_게시판 {
    border-width: 0;
    font-weight: ${({ theme }) => theme.typography.fontWeight.light};

    td {
      border-left: 1px solid transparent;
      border-right: 1px solid transparent;
      border-top: 1px solid transparent;
      border-bottom: 1px solid ${({ theme }) => theme.colors.neutral[200]};
      text-align: left;
      font-size: ${({ theme }) => theme.typography.fontSize.base};

      a {
        overflow: hidden;
        text-overflow: ellipsis;
        width: 260px;
        height: 23px;
        white-space: nowrap;
        display: block;
      }
    }

    th {
      border: none;
      color: ${({ theme }) => theme.colors.neutral[0]};
      background: ${({ theme }) => theme.colors.neutral[700]};
      font-weight: ${({ theme }) => theme.typography.fontWeight.light};
      font-size: ${({ theme }) => theme.typography.fontSize.base};
      border-radius: ${({ theme }) => theme.borderRadius.md};
    }
  }

  .게시판_컨테이너 {
    position: relative;
    width: 100%;
    height: auto;
    min-height: 300px;
    font-size: ${({ theme }) => theme.typography.fontSize.lg};
    border: 1px solid ${({ theme }) => theme.colors.neutral[0]};
    border-radius: ${({ theme }) => theme.borderRadius.md};
    background: ${({ theme }) => theme.colors.neutral[0]};
    box-shadow: ${({ theme }) => theme.elevation.sm};
    padding: ${({ theme }) => theme.spacing[4]};
    box-sizing: border-box;
  }

  .QA_게시판 {
    width: 100%;
    border-spacing: 0;

    td {
      border: 1px solid ${({ theme }) => theme.colors.neutral[0]};
      text-align: left;
      background: ${({ theme }) => theme.colors.neutral[0]};
    }

    th {
      border: 1px solid ${({ theme }) => theme.colors.neutral[300]};
      border-right: none;
      color: ${({ theme }) => theme.colors.neutral[900]};
    }
  }

  .댓글_목록 {
    width: 100%;
    font-size: ${({ theme }) => theme.typography.fontSize.sm};
    padding: 0 ${({ theme }) => theme.spacing[5]};
    text-align: left;
    line-height: 20px;
    word-wrap: break-word;
    white-space: pre-wrap;
  }

  .댓글 li {
    width: 100%;
    word-wrap: break-word;
    white-space: pre-wrap;
  }

  .댓글_div {
    flex-direction: row;
    flex-wrap: nowrap;
    display: inline-flex;
    justify-content: space-between;
    word-wrap: break-word;
    word-break: break-all;
    width: 100%;
  }

  .댓글_시간_div {
    color: ${({ theme }) => theme.colors.neutral[400]};
  }

  .댓글쓰기_버튼 {
    min-width: 50px;
    line-height: 55px;
    vertical-align: text-bottom;
    border: none;
    background: ${({ theme }) => theme.colors.primary[500]};
    color: ${({ theme }) => theme.colors.neutral[0]};
    border-radius: ${({ theme }) => theme.borderRadius.sm};
    cursor: pointer;

    &:hover { background: ${({ theme }) => theme.colors.primary[700]}; }
  }

  .댓글삭제_버튼 {
    min-width: 50px;
    max-height: 24px;
    margin-left: ${({ theme }) => theme.spacing[3]};
    cursor: pointer;
  }

  .댓글_textarea {
    width: 100%;
    height: 60px;
    resize: none;
    margin-right: ${({ theme }) => theme.spacing[1]};
    border: 1px dashed ${({ theme }) => theme.colors.neutral[300]};
    border-radius: ${({ theme }) => theme.borderRadius.sm};
    padding: ${({ theme }) => theme.spacing[2]};
  }

  .작성자_입력기 { width: 100px; }
  .내용_입력기 { width: 320px; }

  .컨텐츠 {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
    margin-bottom: 15vh;
    margin-top: ${({ theme }) => theme.spacing[8]};
  }

  ${media.laptop} {
    .공지사항_헤더 { text-align: center; }
    .작성자_입력기 { width: 50px; }
    .내용_입력기 { width: 100%; }

    .컨텐츠 {
      flex-direction: row;
      width: 100%;
      margin-bottom: 15vh;
    }

    .게시판_컨테이너 {
      width: 100%;
      font-size: ${({ theme }) => theme.typography.fontSize.base};
    }

    .공지사항_게시판 { width: 100%; }

    .QA_게시판 {
      border-width: 0;

      th { font-size: ${({ theme }) => theme.typography.fontSize.xs}; }
      td { font-size: ${({ theme }) => theme.typography.fontSize.xs}; }
    }

    .HelpMasterPanel {
      width: 100%;
      height: 1000px;
    }

    .ProductMasterPanel {
      width: 100%;
      padding-left: ${({ theme }) => theme.spacing[3]};
      list-style-type: none;
    }

    .PortfolioMasterPanel {
      margin: 0;
      width: 100%;
    }

    .CompanyMasterPanel {
      width: 100%;
      list-style-type: none;
      margin: 0;
      padding: 0;
      background: ${({ theme }) => theme.colors.neutral[700]};
    }

    .NoticeMasterPanel {
      width: 100%;
      height: 100%;
      align-items: center;
      text-align: center;
      margin-bottom: 40vh;
    }

    .Wrapper {
      align-items: inherit;
      width: 100%;
      margin: 0;
      padding: 0;
    }

    .DownloadMasterPanel {
      width: 100%;
      align-items: center;
      text-align: center;
    }

    .downbutton { width: 300px; height: 60px; }

    .pix img {
      width: 12.5%;
    }
  }
`;

export default ScreenWrapper;
